import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const names = ['María', 'Laura', 'Silvana', 'Andrea', 'Patricia', 'Valeria', 'Carolina', 'Sofía'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán'];
export function SocialProofPopup() {
  const [show, setShow] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setShow(true);
      setTimeout(() => setShow(false), 4000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000); // First popup after 3 seconds
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-16">
      {show && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 100
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl p-4 max-w-sm border-l-4 border-green-500" data-id="element-17">
          <div className="flex items-start gap-3" data-id="element-18">
            <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-19" />
            <div data-id="element-20">
              <p className="font-bold text-gray-800" data-id="element-21">¡Compra confirmada!</p>
              <p className="text-sm text-gray-600" data-id="element-22">
                <span className="font-semibold" data-id="element-23">{currentPurchase.name}</span> de{' '}
                {currentPurchase.city} acaba de comprar
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-24">Hace 2 minutos</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}